<template>
    <el-container style="height:inherit;width:100%;">
        <!-- 侧边栏 -->
        <el-aside id="elAside" v-bind:class="{ 'aside-scrollbar':true,activeStyle: isActive, 'text-act': isActives }" >
          <el-scrollbar >
            <!-- 侧边栏的logo -->
            <div class="logo_box" v-if="isCollapse == false">
              <img v-if="isDarkMode" src="../assets/img/T2511271.png" class="logo_img"/>
              <img v-else src="../assets/img/T251127.png" class="logo_img" />
              <strong class="logo_crm">CRM</strong>
            </div>
            <div class="logo_collapsed" v-else>
              <strong>TIBIOT</strong>
            </div>
            <!-- 菜单 -->
            <side-list :isCollapse="isCollapse"></side-list>
          </el-scrollbar>
        </el-aside>
        <el-container style="height:inherit;width:100%;">
            <el-header class="crm-header">
              <!-- 控制菜单伸缩 -->
              <span @click="operationMenu" class="crm-icon-btn crm-collapse">
                <i :class="isCollapse == false ? 'el-icon-s-fold' : 'el-icon-s-unfold'"></i>
              </span>
              <!-- 面包屑 -->
              <el-breadcrumb class="crm-crumb">
                <el-breadcrumb-item v-for="(item,index) in crumbsArrss" :key="index">{{item}}</el-breadcrumb-item>
              </el-breadcrumb>
              <div class="crm-spacer"></div>
              <!-- 客户搜索 -->
              <el-input placeholder="支持2位以上公司名称、11位手机号精准搜索" v-model.trim="cusName" @submit.native.prevent clearable size="small" class="crm-search input-with-select">
                <el-button slot="append" icon="el-icon-search" style="padding-left: 13px;padding-right: 13px;" :loading="isSearch" @click="SearchCustomers()"></el-button>
              </el-input>
              <!-- 客户回访 -->
              <el-tooltip content="+ 客户回访信息" placement="bottom">
                <span class="crm-icon-btn" @click="addvisit">
                  <i class="el-icon-edit-outline" style="font-size: 19px;"></i>
                </span>
              </el-tooltip>
              <!-- 多平台入口 -->
              <el-tooltip content="前往多平台登录入口" placement="bottom">
                <span class="crm-icon-btn" @click="goCard()">
                  <i class="el-icon-map-location" style="font-size: 19px;"></i>
                  <!-- <img src="../assets/img/goCard.png"  style="width: 26px;height: 26px;"/> -->
                </span>
              </el-tooltip>
              <!-- 主题切换 -->
              <span class="crm-icon-btn" @click="toggleTheme">
                <i :class="isDarkMode ? 'el-icon-sunny' : 'el-icon-moon'" style="font-size: 19px;"></i>
              </span>
              <span class="crm-divider"></span>
              <!-- 用户的信息和退出 -->
              <el-dropdown class="crm-user" @command="handleCommand">
                <span class="crm-user-inner">
                  <span class="crm-avatar">{{ (userName || 'U').slice(0,1) }}</span>
                  <span class="crm-username">{{userName}}</span>
                  <i class="el-icon-arrow-down"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item icon="el-icon-user" command="个人中心"> 个人中心</el-dropdown-item>
                  <el-dropdown-item icon="el-icon-switch-button" command="退出平台"> 退出平台</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </el-header>
            <!-- tabs视图 -->
            <div class="tabsViews">
              <tabsViews/>
            </div>
            <el-main id="elMain">
              <el-scrollbar style="height:100%;" class="main-scorllbar">
                <!-- 主体内容 -->
                <div id="mainView">
                  <transition name="fade-transform" mode="out-in">
                    <keep-alive :include="cachedViews">
                      <router-view style="padding:20px 4px 20px;" ></router-view>
                    </keep-alive>
                  </transition>
                </div>
                <!-- 返回顶部 -->
                <el-backtop target="#elMain .el-scrollbar__wrap" :bottom="72" :right="22"></el-backtop>
              </el-scrollbar>
            </el-main>
            <el-footer style="height:14px;"></el-footer>
        </el-container>
        <el-dialog
            title="退出平台，你确定吗？"
            :visible.sync="SignOut.show"
            width="540px"
            :close-on-click-modal="false"
            >
              <div style="text-align:center;margin-top:14px;">
                <div style="height:260px;" class="re">
                  <img class="ab" src="../assets/img/tuichu.png" alt="" style="width:300px;top:-38px;left:86px;">
                </div>
            </div>
            <span slot="footer" class="dialog-footer" >
                <el-button size="mini" round type="primary" icon="el-icon-close" @click="cancel('SignOut')">取 消</el-button>
                <el-button size="mini" round type="primary" icon="el-icon-check" @click="handleAdopt('SignOut')">确 定</el-button>
            </span>
        </el-dialog>
        <el-drawer title="已存在客户相关信息" :visible.sync="tableDataObj.show"  :size="850">
          <div style="padding: 12px;">
            <p v-if="handleType == 'customer'" style="margin: 0 0 8px; font-size: 13px; color: #e6a23c;">
              <i class="el-icon-info"></i> 点击行左侧图标，可展开/折叠查看关联客户
            </p>
            <el-table
              border
              :data="tableDataObj.tableData"
              style="width: 100%;"
              :default-expand-all="tableDataObj.tableData.length < 6"
              :key="'expand-' + (tableDataObj.tableData.length < 6)"
              @header-click="statusHandle"
              >
              <el-table-column type="expand" width="50" :label="status" class="point" v-if="handleType == 'customer'">
                <template slot-scope="scope">
                  <div style='padding:2px 12px;'>
                    <el-table
                      :show-header="false"
                      :data="scope.row.relations"
                      :max-height="134"
                      border
                      empty-text="暂无关联客户"
                      style="width: 100%">
                      <el-table-column prop="gradeName" label="客户等级" width="80">
                        <template slot-scope="scope1">
                          <strong class="c_color">关联客户 <i>{{scope1.$index + 1}}</i></strong>
                        </template>
                      </el-table-column>
                      <el-table-column prop="gradeName" label="客户等级" align="center" width="80">
                        <template slot-scope="scope1">
                          <span class="c_color"> {{scope1.row.gradeName }}</span> 
                        </template>
                      </el-table-column>
                      <el-table-column prop="cusName" label="关联客户" >
                        <template slot-scope="scope1">
                          <span class="c_color"> {{scope1.row.cusName }}</span> 
                        </template>
                      </el-table-column>
                      <el-table-column prop="relationName" label="关联关系" width="136">
                        <template slot-scope="scope1">
                          <span class="c_color"> {{scope1.row.relationName }}</span> 
                        </template>
                      </el-table-column>
                      
                      <el-table-column prop="staffName" label="所属销售" width="90">
                        <template slot-scope="scope1">
                          <span class="c_color"> {{scope1.row.staffName ? scope1.row.staffName :'暂无销售'}}</span> 
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </template>
            </el-table-column>
            <el-table-column prop="cusName" label="客户">
               <template slot-scope="scope">
                <span class="them_colors">{{scope.row.cusName}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="businessLine" label="业务线" width="80" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.businessLine == 1" class="them-color-i">国际</span>
                <span v-else-if="scope.row.businessLine === 0" class="them-color">国内</span>
                <template v-else>-</template>
              </template>
            </el-table-column>
            <el-table-column prop="cusGradeName" label="客户等级" align="center" width="83">
              <template slot-scope="scope">
                <span class="them_colors">{{scope.row.cusGradeName}}</span> 
              </template>
            </el-table-column>
            <el-table-column prop="deptName" label="销售信息" align="center" width="126">
              <template slot-scope="scope">
                <span class="them_colors"><template v-if="scope.row.deptName">{{scope.row.deptName}}</template><template v-else>公海客户</template> ～ {{scope.row.staffName ? scope.row.staffName : '-'}}</span> 
              </template>
            </el-table-column>
            <el-table-column prop="rawAddTime" label="编辑时间" align="center" width="140">
              <template slot-scope="scope">
                <span class="them_colors">{{scope.row.rawAddTime ? moment(scope.row.rawAddTime).format('YYYY-MM-DD HH:mm:ss') : '-'}}</span> 
              </template>
            </el-table-column>
            <el-table-column prop="expireDate" label="保护到期日期" align="center" width="107">
              <template slot-scope="scope">
                <p class="them_colors" v-if="scope.row.expireDate && scope.row.cusGradeName == '报价客户'">{{ moment(scope.row.expireDate).format('YYYY-MM-DD') }}</p>
                <p class="them_colors" v-else>-</p>
              </template>
            </el-table-column>
          </el-table>
          <paginaitionSmall v-if="handleType == 'customer'" :pageNum="paging.page" :totalSize="tableDataObj.totalSize" @handleSizeChange="handleCurrentChange"></paginaitionSmall>
          </div>
        </el-drawer>
         <!-- 添加 / 修改 -->
        <el-dialog :title="title" :visible.sync="handelUser.show"  width="600px" :close-on-click-modal='false' :close-on-press-escape='false'>
            <el-form ref="handelUser" :model="handelUser.form" :rules="handelUser.rules" label-width="86px" size="small" >
                <el-form-item label="回访客户" prop="cusCode">
                    <el-select v-model="handelUser.form.cusCode" filterable :loading="handelUser.loading" remote reserve-keyword :remote-method="getCusOpt" style="width:440px;">
                        <el-option v-for="item in handelUser.cusOpt" :key="item.val" :label="item.name" :value="item.val"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="回访类型" prop="visitType">
                    <el-select v-model="handelUser.form.visitType" style="width:440px;">
                        <el-option label="电话回访" :value="1"></el-option>
                        <el-option label="客服售后" :value="4"></el-option>
                        <!-- <el-option label="出差拜访" :value="2"></el-option>
                        <el-option label="本地拜访" :value="3"></el-option> -->
                    </el-select>
                </el-form-item>
                <p style="border-bottom:1px solid #2c3244;margin:32px 0;"></p>
                <el-form-item label="回访日期" prop="visitTime">
                    <el-date-picker  v-model="handelUser.form.visitTime" type="date" :picker-options="pickerOptions"></el-date-picker>
                </el-form-item>
                
                <el-form-item label="回访概要" prop="visitOutline">
                    <el-input type="textarea" v-model="handelUser.form.visitOutline" resize="none" maxlength="2000" :rows='8' show-word-limit ></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" v-if="!handelUser.isLoading" round type="primary" icon="el-icon-close" @click="cancel('handelUser')">取 消</el-button>
                <el-button size="mini" v-if="!handelUser.isLoading" round type="primary" icon="el-icon-check" @click="Determine('handelUser')">确 定</el-button>
                <el-button type="primary"  size="mini" v-if="handelUser.isLoading" round icon="el-icon-finished" :loading="true">数据正在处理中...</el-button>
            </span>
        </el-dialog>
    </el-container>
</template>

<script>
import SideList from './SideList.vue'
import paginaitionSmall from '../publicComponents/paginaitionSmall.vue';
import queryBox from '../publicComponents/queryBox'
import { mapState, mapMutations,mapActions } from "vuex";
import tabsViews from './tabsViews'
import moment from 'moment'
  export default {
    name: 'Main',
    data () {
      return {
        isDarkMode: false,
        isSearch:false,
        isCollapse:false,
        isActive:true,
        isActives:false,
        SignOut:{
          show:false,
        },
        roleId:'',
        cusName:"",
        handelSearchCustomer:{
          show:false,
          tableData:{
            cusName:''
          },
          tableData1: []
        },
        //表格数据
        tableDataObj: { //列表数据
            loading:false,
            show:false,
            tableData: [],
            totalSize:0,//公司名检测分页总条数
        },
        status:'展开', //用于列表展开折叠的判断
        pickerOptions:{
            disabledDate(time) {
                return time.getTime() > Date.now();
            }
        },
        //添加回访记录
        handelUser:{
            show:false,
            isLoading:false,
            loading:false,
            form:{
                cusCode:'',
                cusName:"",
                visitTime:new Date(),
                visitOutline:'',
                visitName:this.$store.state.userName,
                visitType:1,
            },
            rules:{
                cusCode:[ { required: true, message:'请选择回访客户', trigger: ["blur", "change"]} ],
                visitTime:[ { required: true, message:'请选择回访日期', trigger: ["blur", "change"]} ],
                visitOutline:[ { required: true, message:'请输入回访概要', trigger: ["blur", "change"]} ],
                visitType:[ { required: true, message:'请选择回访类型', trigger: ["blur", "change"]} ],
            },
            cusOpt:[],
        },
        title:"",
        paging:{page:1,pageSize:10}, //公司名称检测分页
        handleType:'mobile', // mobile 手机号 customer 客户
      }
    },
    components:{
      SideList,paginaitionSmall,queryBox,tabsViews
    },
    computed:{
      ...mapState({  //比如'movies/hotMovies
        userName:state=>state.userName
      }),
      crumbsArrss(){
        return this.$store.state.crumbsArr;
      },
      cachedViews(){
        return this.$store.state.cachedViews;
      },
      listObj:function(){
            let a = [], data = this.tableDataObj.tableLabel;
            for(let i =0; i< data.length;i++){
                if(data[i].query == true){
                    a.push(data[i]);
                }
            }
            return a;
        },
    },
    created(){
      // 初始化主题状态
      const savedTheme = localStorage.getItem('theme')
      if (savedTheme) {
          this.isDarkMode = savedTheme === 'dark'
      } else {
          this.isDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches
      }
      this.$router.push('/home');
      
    },
    methods:{
      ...mapActions([  //比如'movies/getHotMovies
        'saveInfo',
        'saveMenuWidth'
      ]),
      toggleTheme() {
          this.isDarkMode = !this.isDarkMode
          // 调用全局主题切换方法
          this.$root.$toggleTheme()
      },
      //(确定))退出
      handleAdopt(){
        this.$api.get(this.API.IgwIar + 'com/logout',{},res=>{
          if(this.$common.getCookie('tibiot-crm')){
            document.cookie='tibiot-crm='+ this.$common.getCookie('tibiot-crm') +';path=/;expires=Thu,01 Jan 1970 00:00:00 GMT';  //清除token
            window.localStorage.removeItem("vuex-along"); //清除vue-along
          }
          window.location.href = res.data;
        })
      },
      //取消
      cancel(name){
        this[name].show = false; //弹框关闭
        this.$message.info('已取消操作');
      },
      handleCommand(command){
        if(command == '退出平台'){
          this.SignOut.show = true;
        }else if(command == '个人中心'){
          this.$router.push('/personalInfo');
        }
      },
      //菜单收缩
      operationMenu(){
        let a = document.getElementById('elAside');
        this.isCollapse =!this.isCollapse;
        this.isActive = !this.isActive;
        this.isActives = !this.isActives;
        this.saveMenuWidth({menuWidth:(300 - a.offsetWidth)});
      },
      //搜素客户
      SearchCustomers(){
        if(this.cusName.length >= 2 && ( this.cusName != "有限公司" && this.cusName != "科技有限公司" && this.cusName != "科技" && this.cusName != "有限" && this.cusName != "公司")){
          if(Number(this.cusName)){
            // 纯数字表示手机号
            if(!/^1[3456789]\d{9}$/.test(this.cusName)){
              this.$message.error('请输入正确的手机号');
            }else{
              this.isSearch = true;
              this.handleType = 'mobile';
              // 用手机号检测
              this.DetectionInput('man/isPhoneBoundToContacts?mobile=' + this.cusName);
            }
          }else{
            // 用公司名称检测
            this.isSearch = true;
            this.handleType = 'customer';
            this.paging.page = 1;
            this.searchCusByName();
          }
        }else{
          this.$message.warning("至少输入2个字，且不能是“科技、有限、公司、有限公司、科技有限公司”等字样！");
          
        }
      },
      // 检测结果的无数据/错误提示（公司名、手机号共用）
      showDetectMessage(res){
        if(res.code == 10059 || res.code == 21029){
          this.$message.error(res.message);
        }else if(res.code == 1000){
          this.$message.success(res.message);
        }else{
          this.$message.success('恭喜！暂无记录，可录入该客户。');
        }
      },
      // 检测是否可录入（手机号）
      DetectionInput(url){
        this.$api.get(this.API.IgwIoa + url, {},res=>{
          this.isSearch = false;
          if(res.code == 200 && res.data.length){
            this.tableDataObj.tableData = res.data;
            this.tableDataObj.show = true;
          }else{
            this.showDetectMessage(res);
          }
        });
      },
      // 公司名称检测（后端分页）
      searchCusByName(){
        this.$api.get(this.API.IgwIoa + 'cus/query/one/by/name', { cusName:this.cusName, page:this.paging.page, pageSize:this.paging.pageSize },res=>{
          this.isSearch = false;
          if(res.code == 200 && res.data.length){
            this.tableDataObj.tableData = res.data;
            this.tableDataObj.totalSize = res.total;
            //数据少于6条时默认展开，同步表头展开/折叠状态
            this.status = res.data.length < 6 ? '折叠' : '展开';
            this.tableDataObj.show = true;
          }else{
            this.showDetectMessage(res);
          }
        });
      },
      // 公司名称检测分页翻页（小型分页，固定每页10条）
      handleCurrentChange(page){
        this.paging.page = page;
        this.searchCusByName();
      },
      // 跳往多平台登录口
      goCard(){
        this.$api.get(this.API.IgwIar + 'admin/inner/skip/SYSTEM_0', {},res=>{
          if(res.code == 200){
            let {sysCode, authToken} = res.data;
            window.open(res.data.jumpUrl + "?param=" + JSON.stringify({sysCode, authToken}), "_blank");
          }else{
            this.$message.error(res.message);
          }
        });
      },
      //控制展开折叠
      statusHandle(column, event){
          if(column.type =="expand"){
              this.expandOpen();
          }
      },
      expandOpen(){
          var arr = document.querySelectorAll(".el-table__expand-icon");
          for(var i = 0; i< arr.length; i++){
              if(arr[i].className.length<25){
                  arr[i].onclick = function(){}
              }else{
                  arr[i].onclick = function(){}
              }
          }
          if(this.status == "展开"){
              for (var i = 0; i < arr.length; i++){
                  if(arr[i].className.length<25){
                      arr[i].click()
                  }
              }
              this.status = "折叠"
          }else{
              for(var i = 0 ;i < arr.length; i++){
                  if(arr[i].className.length > 25){
                      arr[i].click()
                  }
              }
              this.status = "展开"
          }
      },
      addvisit(){
        this.title = '添加回访信息';
        this.handelUser.show = true;
      },
      //获取客户名下拉框
      getCusOpt(query){
          if(query.length >= 1 && query.trim().length >= 1){
            this.handelUser.loading = true;
            this.$api.get(this.API.IgwIoa + 'cus/query/base/info?cusName='+query,{},res=>{
              this.handelUser.cusOpt = res.data;
              this.handelUser.loading = false;
            });
          }
        },
         //添加用户的确定
        Determine(formName){
            if(this.title == '添加回访信息'){
                this.$refs[formName].validate((valid,val) => {
                    if (valid) {
                        let {cusCode,visitTime,visitOutline,cusName,visitType} = this.handelUser.form;
                        let params = {};
                        Object.assign(params,{cusCode,visitTime,visitOutline,cusName,visitType});
                        this.sendRequest('post','确定添加回访信息吗？','visit/save',params,formName);
                    } else {
                        return false;
                    }
                });
            }
        },
        //发送请求
        sendRequest(method,tips,url,obj,formName){
            if(formName){
              this[formName].isLoading = true;
            }
            this.$confirms.confirmation(method,tips,'温馨提示','warning',this.API.IgwIoa + url,obj,res =>{
              if(formName){
                this[formName].show = false;
                this[formName].isLoading = false;
              }
            },callback =>{
                if(formName){
                    this[formName].isLoading = false;
                }
            });
        },
    },
    watch:{
      'handelUser.show':{
            handler(val){
                if(!val){
                    this.$refs.handelUser.resetFields();
                    this.handelUser.form.cusCode = '';
                    this.handelUser.form.cusName = '';
                    this.handelUser.cusOpt = [];
                }
            }
        },
        //根据主管code获取主管名称
        'handelUser.form.cusCode':{
            handler(val){
                if(val){
                    if(this.handelUser.cusOpt.length){
                        this.handelUser.form.cusName = this.handelUser.cusOpt.find(ele=>ele.val == val).name;
                    }
                }else{
                    this.handelUser.form.cusName = '';
                }
            }
        }
    }
  }
</script>
<style scoped>
  /* ============ 卡片基底（令牌驱动）============ */
  .el-header {
    margin: 14px 14px 7px 0px;
    border-radius: var(--crm-radius) var(--crm-radius) 0px 0px;
    background-color: var(--crm-card-bg);
    box-shadow: var(--crm-shadow);
  }
  .tabsViews {
    margin: 0px 14px 14px 0px;
    border-radius: 0px 0px var(--crm-radius) var(--crm-radius);
    background-color: var(--crm-card-bg);
    box-shadow: var(--crm-shadow);
  }
  #elAside .el-scrollbar {
    margin: 14px;
    border-radius: var(--crm-radius);
    height: calc(100% - 28px);
    background-color: var(--crm-card-bg);
    box-shadow: var(--crm-shadow);
  }
  .el-main {
    padding: 0 !important;
    border-radius: var(--crm-radius);
    overflow: hidden;
    margin-right: 14px;
    background-color: var(--crm-card-bg);
    box-shadow: var(--crm-shadow);
  }
  #mainView {
    padding: 0px 15px;
    box-sizing: border-box;
    overflow: hidden;
  }

  /* ============ 侧边栏 logo ============ */
  .logo_box {
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 0px 18px 30px 18px;
    border-bottom: 1px solid var(--crm-border);
  }
  .logo_img {  width: 86px; margin-left: 8px;}
  .logo_crm { font-size: 23px; color: #0a6cd2; margin-left: 5px;font-weight: 700; }
  .logo_collapsed {
    padding: 22px 0px 16px;
    color: var(--crm-text);
    font-size: 15px;
    text-align: center;
  }

  /* ============ 顶栏（flex 布局）============ */
  .crm-header {
    display: flex !important;
    align-items: center;
    gap: 9px;
    height: 57px !important;
    padding: 0 18px !important;
  }
  .crm-spacer { flex: 1; }
  .crm-crumb { font-size: 14px; flex-shrink: 0; }

  /* 通用图标按钮 */
  .crm-icon-btn {
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border-radius: var(--crm-radius-sm);
    color: var(--crm-text-2);
    cursor: pointer;
    transition: background .15s, color .15s;
  }
  .crm-icon-btn i { font-size: 18px; }
  .crm-icon-btn:hover { background: var(--crm-hover); color: var(--primary-color); }
  .crm-collapse i { font-size: 20px; }

  /* 搜索框 */
  .crm-search { width: 350px; flex-shrink: 0; }

  /* 分隔线 */
  .crm-divider { width: 1px; height: 20px; background: var(--crm-border); flex-shrink: 0; }

  /* 用户区 */
  .crm-user { flex-shrink: 0; cursor: pointer; }
  .crm-user-inner {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 4px 6px;
    border-radius: var(--crm-radius-sm);
    transition: background .15s;
  }
  .crm-user:hover .crm-user-inner { background: var(--crm-hover); }
  .crm-avatar {
    width: 32px; height: 32px; border-radius: 50%;
    background: linear-gradient(135deg, var(--primary-color), #5aa8ff);
    color: #fff; font-size: 16px; font-weight: 700;
    display: flex; align-items: center; justify-content: center;
  }
  .crm-username { font-size: 13px; font-weight: 600; color: var(--crm-text); }
  .crm-user-inner .el-icon-arrow-down { font-size: 12px; color: var(--crm-text-3); }

  /* ============ 折叠宽度 ============ */
  .activeStyle {
    height: inherit !important;
    width: 240px !important;
    transition: width 0.22s;
  }
  .text-act {
    height: inherit !important;
    width: 92px !important;
    transition: width 0.22s;
  }

  /* ============ 其它 ============ */
  .them_colors { color: #ccaf56; }
  .c_color { color: #92a0e4; }

  /* 路由切换过渡 */
  .fade-transform-leave-active,
  .fade-transform-enter-active { transition: all .3s; }
  .fade-transform-enter { opacity: 0; transform: translateX(-30px); }
  .fade-transform-leave-to { opacity: 0; transform: translateX(30px); }
</style>
<style>
  /* 搜索框内部样式（穿透 el-input） */
  .crm-search .el-input__inner {
    border-radius: var(--crm-radius-sm) 0 0 var(--crm-radius-sm);
    border-color: var(--crm-border);
  }
  .crm-search .el-input-group__append {
    border-radius: 0 var(--crm-radius-sm) var(--crm-radius-sm) 0;
    background: var(--crm-hover);
    border-color: var(--crm-border);
  }
  /* 返回顶部 */
  .el-backtop {
    box-shadow: 0 2px 8px rgba(0,0,0,.15);
    color: var(--crm-text-2);
    transition: background-color .15s, color .15s;
  }
  .el-backtop:hover {
    background-color: var(--primary-color);
    color: #fff;
  }
  /* 面包屑最后一项加粗 */
  .crm-crumb .el-breadcrumb__item:last-child .el-breadcrumb__inner {
    color: var(--crm-text);
    font-weight: 600;
  }
  /* 禁止横向滚动条 */
  .aside-scrollbar .el-scrollbar__wrap,
  .main-scorllbar .el-scrollbar__wrap {
    overflow-x: hidden !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Main.vue